@app.controller 'JouleAppMainHeroController', (mobileDetectionService, responsiveService) ->

  @isMobileDevice = mobileDetectionService.isMobile
  @isViewportMobile = responsiveService.isViewportMobile()
  @showDesktopImage = responsiveService.isViewportGT(500)
  @youtubeId = '9D-Btpd0_rY'
  @image = 'https://d3awvtnmmsvyot.cloudfront.net/api/file/lNUnuCDtQIulqCp7MFKo'
  @mobileImage = 'https://d3awvtnmmsvyot.cloudfront.net/api/file/MOEHZ53mTRaax61NjK9u'
  this
